import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPaymentGatewayOption.ts
var t = () => e("paymentGatewayOption");
//#endregion
export { t as useTrPaymentGatewayOption };
